import { render } from "./StudyLegendDialogs.vue?vue&type=template&id=8533ba6a&scoped=true"
import script from "./StudyLegendDialogs.vue?vue&type=script&lang=js"
export * from "./StudyLegendDialogs.vue?vue&type=script&lang=js"

import "./StudyLegendDialogs.vue?vue&type=style&index=0&id=8533ba6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8533ba6a"]])

export default __exports__